import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/default.vue").then(m => m.default || m))
}